import axios from "axios"
import { LANDING_PAGES_URL } from "src/constants"

export const createLandingPageUrl = async (data) => {
   return await axios.post(LANDING_PAGES_URL, data)
}
